export default "__VITE_ASSET__CsCB3mgO__"